module.exports = __webpack_public_path__ + "img/berlinerkranse_sukker_2.3120feaa.jpg";